import store from "@/store";
import { transformText } from "./textUtils";
import ptOverrides from "@/i18n/ptOverrides";
import esOverrides from "@/i18n/esOverrides";

const translationsByLanguage = new Map();

function normalizeLanguage(language) {
    const selectedLang = language || 'en';
    return selectedLang.toLowerCase().split('-')[0];
}

function mergeOverrides(language, translations) {
    if (language === 'pt')
        translations = { ...translations, ...ptOverrides };
    if (language === 'es')
        translations = { ...translations, ...esOverrides };
    return translations;
}

export async function loadTranslations(language = store.getters.getUserLang || 'en') {
    const useLang = normalizeLanguage(language);
    if (translationsByLanguage.has(useLang)) {
        return translationsByLanguage.get(useLang);
    }

    let translations = {};
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 5000);
    try {
        const response = await fetch(`/data/lang/${useLang}.json`, {
            signal: controller.signal
        });
        if (response.ok) {
            translations = await response.json();
        }
    } catch (_) {
        // The interface remains usable with its source strings when offline.
    } finally {
        window.clearTimeout(timeout);
    }

    translations = mergeOverrides(useLang, translations);
    translationsByLanguage.set(useLang, translations);
    store.dispatch('saveTranslations', translations);
    return translations;
}

export function getAllTranslations() {
    const useLang = normalizeLanguage(store.getters.getUserLang || 'en');
    if (translationsByLanguage.has(useLang)) {
        return translationsByLanguage.get(useLang);
    }

    return {};
}

export function translate(text = '', textTransform = '') {
    if(!text || text == '')
        return text;
    try {
        const translations = getAllTranslations();
        const normalizedText = typeof text === 'string' ? text.toLowerCase() : text;
        const translationKey = translations[text] !== undefined ? text : normalizedText;
        if(translations[translationKey] === undefined || translations[translationKey] === null || translations[translationKey] === '')
            return transformText(text, textTransform);
        return translations[translationKey] === undefined || translations[translationKey] === null
                ? transformText(text, textTransform)
                : transformText(translations[translationKey], textTransform);
    } catch (error) {
        console.error(error);
        return text;
    }
}
